import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import { baixarArquivo } from "../../utils/downloadUtil";
import './ConjuntoArquivosGrandesVolumes.css';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Tooltip } from "../UI/Tooltip/Tooltip";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }


const mapStateToProps = (state) => {
    return {
        user: state.usuarioStore.user,
        filters: state.filterStore,
    }
}

export const ConjuntoArquivoGrandesVolumesView =

withRouter(

// redux
connect(
    (mapStateToProps), 
    (mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				conjuntoArquivoGV: {},
				anexo: {
					id: '',
					fornecedora: '',
					tipo: '',
					arquivo: null,
					nomeArquivo: null,
					obrigatorioAdesao: false,
				},
				tipos: [],
				anexos: [],
				documentosConjunto: [],
				carregandoDocumentosConjunto: false,
				arquivosConjunto: [],
				carregandoArquivosConjunto: false,
				carregandoTipos: false,
				exibeModalExcluir: false,
				botoesHabilitados: true,
			};
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Conjuntos de Arquivos de Grandes Volumes - Detalhes</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			if(id){
				api.get(`/api/conjunto-arquivo-gv/${id}`)
					.then(response => { 
						this.setState(
							{
								conjuntoArquivoGV: response.data,
							})
							
					})
					.catch(erro => {
						console.log("Não foi possível recuperar o conjunto de arquivos de grandes volumes " + erro);
						this.props.exibeMensagemErro("Erro durante o carregamento da página");
					});
					this.carregarDocumentos();
					this.carregarArquivos();
			}
		}

		renderForm() {
			const { conjuntoArquivoGV, documentosConjunto, arquivosConjunto, carregandoArquivosConjunto, carregandoDocumentosConjunto } = this.state;
			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Título:</label>
										{conjuntoArquivoGV.titulo}
									</div>
								</div>
							</div>
						
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Esfera Administrativa:</label>
										{conjuntoArquivoGV.esferasAdministrativas && conjuntoArquivoGV.esferasAdministrativas.length > 0 ? conjuntoArquivoGV.esferasAdministrativas.map(ea => ea.nome).join(", ") : ""}
									</div>
								</div>
							</div>
						</div>

						
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Órgão Fornecedor:</label>
										{conjuntoArquivoGV.nomeOrgao}
									</div>
								</div>
							</div>
						
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Ativo:</label>
										{conjuntoArquivoGV.ativo ? "Sim" : "Não"}
									</div>
								</div>
							</div>
						</div>

						<fieldset className="mb-4">
							<div className="d-flex align-items-center" style={{margin: "24px 0"}}>
								<span className="text-primary fw-normal" style={{fontSize: "22px"}}>Arquivos&nbsp;</span>
								<Tooltip 
									content={
										<>
											<span>Os arquivos a serem transferidos para os órgãos consumidores devem ser disponibilizados na pasta <strong>Outbox da Pasta Segura</strong>.</span>
											<span>O nome do arquivo deve ser conforme o cadastro aprovado, podendo ser acrescentado algum sufixo para permitir diferenciar e transferir vários arquivos.</span>
											<span>Manter sempre o nome principal  e acrescentar o caracter underline (“_”) mais o sufixo desejado, preferencialmente uma data.</span>
											<span>&nbsp;</span>
											<span>Exemplos:</span>
											<span>&emsp;Nome do arquivo no cadastro : <strong>DadosCenso</strong></span>
											<span>&emsp;Extensão : <strong>zip</strong></span>
											<span>&nbsp;</span>
											<span>Possíveis nomes do arquivo a ser disponibilizado na pasta <strong>Outbox</strong> para transferência: 	</span>
											<span>&emsp;<strong>DadosCenso.zip</strong></span>
											<span>&emsp;<strong>DadosCenso_2025.zip</strong></span>
											<span>&emsp;<strong>DadosCenso_2024.zip</strong></span>
											<span>&emsp;<strong>DadosCenso_20240101.zip</strong></span>
											<span>&nbsp;</span>
											<span>O arquivo só será transferido para as pastas <strong>Inbox</strong>  dos órgãos consumidores caso o nome satisfaça a regra acima.</span>	
										</>
									}
								/>								
							</div>
							{(arquivosConjunto && arquivosConjunto.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Nome</th>
												<th scope="col">Descrição</th>
												<th scope="col">Extensão</th>
												<th scope="col">Tamanho em MB (Megabytes)</th>
												<th scope="col">Periodicidade</th>
												<th className="text-center" scope="col"style={{width: "5%"}}>Ativo</th>
												
											</tr>
										</thead>
										
										<tbody>
											{ arquivosConjunto.map((arq, index) =>
													<tr key={index} >
														<td>{arq.nome}</td>
														<td>{arq.descricao}</td>
														<td>{arq.nomeExtensaoArquivo}</td>
														<td>{arq.tamanho}</td>
														<td>{arq.nomePeriodicidade}</td>
														<td className="text-center">
															<div className="actions">
																<input 
																	type="checkbox" 
																	checked={arq.ativo !== false}
																	readOnly
																/>
															</div>
														</td>
													</tr>
												)}
										</tbody>
									</table>
								</div>
							</div>
							}
							{ carregandoArquivosConjunto === false  && (arquivosConjunto.length === 0) &&
								<div>
									Nenhum arquivo cadastrado para o conjunto de arquivos de grandes volumes.
								</div>
							}
							{ carregandoArquivosConjunto === true  && 
								<button className="br-button is-secondary is-circle is-loading" type="button"/>
							}
						</fieldset>
						<fieldset>
							<legend>Documentos</legend>
							{(documentosConjunto && documentosConjunto.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>
											<thead>
												<tr>
													<th scope="col">Nome</th>
													<th className="text-center" scope="col" style={{width: "5%"}}>Ações</th>
												</tr>
											</thead>
											
											<tbody>
												{ documentosConjunto.map((documento, index) =>
														<tr key={index} >
															<td>{documento.nomeArquivo}</td>
							
															<td className="text-center">
																<div className="actions">
																	<button type="button" disabled={this.state.botoesHabilitados === false} title="Download do arquivo" onClick={() => this.downloadDocumento(documento.id, documento.nomeArquivo)}>
																		<span className="sr-only">Download</span>
																		<i className="fas fa-download"></i>
																	</button>
																</div>
															</td>
														</tr>
													)}
											</tbody>
										</table>
									</div>
								</div>
							}

							{ carregandoDocumentosConjunto === false  && (documentosConjunto.length === 0) &&
								<div>
									Nenhum documento cadastrado para o conjunto de arquivos de grandes volumes.
								</div>
							}
							{ carregandoDocumentosConjunto === true  && 
								<button className="br-button is-secondary is-circle is-loading" type="button"/>
							}
						</fieldset>

                        <div className="actions-button mt-3">
							<div className="actions justify-content-start">

                                { conjuntoArquivoGV.permiteAlteracao &&     
									<Link to={`/arquivo-grandes-volumes/edit-conjunto-gv/${conjuntoArquivoGV.id}`}>
                                    	<button type="button" className="button is-primary botaoNovo">Solicitar Alteração do Conjunto</button>
                                	</Link>       
                                }

                                { conjuntoArquivoGV.permiteAdesao &&
									<Link to={`/solicitacao-adesao-arquivo-gv/new?conjuntoArquivo=${conjuntoArquivoGV.id}`}>
                                		<button type="button" className="button is-primary botaoNovo">Solicitar Adesão</button>
									</Link>
                                
                                }

                                 { this.props.user.isAdministrador === true &&
                                    <Link to={`/conjunto-arquivo-grandes-volumes/attachments/${conjuntoArquivoGV.id}`}>
                                       <button type="button" className="button is-primary botaoNovo">Cadastrar Anexos</button>
                                    </Link>		
                                }

								<ButtonBack disabled={!this.state.botoesHabilitados} />								
							</div>
						</div>
					</div>
				</div>
			);
		}

		carregarDocumentos(){
			const id = this.props.match.params.id;

			if(!id) return;

			this.setState({
				carregandoDocumentosConjunto: true,
			})
			api.get(`/api/conjunto-arquivo-gv/documento/${id}`)
				.then(response => { 
					this.setState(
						{
							documentosConjunto: response.data,
						}
					) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os documentos do conjunto de grandes volumes." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento dos documentos do conjunto de grandes volumes.")
				}).finally(() => {
					this.setState({carregandoDocumentosConjunto: false})
				});
		}

		carregarArquivos() {
			const id = this.props.match.params.id;

			if(!id) return;

			this.setState({
				carregandoArquivosConjunto: true,
			})
			api.get(`/api/arquivo-gv/conjunto-arquivo-gv/${id}?ativos=false`)
				.then(response => { 
					this.setState(
						{
							arquivosConjunto: response.data,
						}
					) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os arquivos do conjunto de grandes volumes." + erro)
					this.props.exibeMensagemErro("Erro durante o carregamento dos arquivos do conjunto de grandes volumes.")
				}).finally(() => {
					this.setState({carregandoArquivosConjunto: false})
				});
		}

		downloadDocumento(idAnexo, nomeAnexo){
			this.props.mostraAguardando();

			const options = {
				method: 'get',
				url: `/api/conjunto-arquivo-gv/documento/${idAnexo}/download`,
				responseType: 'arraybuffer'
			}

			api(options)
				.then((response) => {
					baixarArquivo(new Blob([response.data]), nomeAnexo);
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o modelo.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

	}

) // redux
); // router